<template>
  <div :class="s.contentPublicInfo">
    <p :class="s.textLeft">
      <br>
    </p>
    <div :class="s.textLeft">
    </div>
    <table :class="s.infosTable">
      <tbody>
        <tr>
          <td colspan="1">披露机构全称:</td>
          <td colspan="1">广东智选保险代理有限公司</td>
        </tr>
        <tr>
          <td colspan="1">披露机构简称:</td>
          <td colspan="1">智选保代</td>
        </tr>
        <tr>
          <td colspan="1">经营互联网保险业务的网站名称：</td>
          <td colspan="1">智选保险管理系统</td>
        </tr>
        <tr>
          <td colspan="1">经营互联网保险业务的网站地址：</td>
          <td colspan="1">http://www.yhtdbx.com/</td>
        </tr>
        <tr>
          <td colspan="1">经营互联网保险业务的APP名称</td>
          <td colspan="1">小鹏汽车</td>
        </tr>
        <tr>
          <td colspan="1">经营互联网保险业务的微信公众号名称：</td>
          <td colspan="1">智选保代</td>
        </tr>
        <tr>
          <td colspan="1">客户服务及消费者投诉电话：</td>
          <td colspan="1">4000145002</td>
        </tr>
        <tr>
          <td colspan="1">机构信息披露网站地址：</td>
          <td colspan="1">
            <a href="http://icid.iachina.cn/ICID/" target="_blank">www.yhtdbx.com</a>
          </td>
        </tr>
      </tbody>
    </table>
    <table :class="s.orgsTable">
      <thead>
        <tr>
          <th colspan="4">当前落地服务机构详情</th>
        </tr>
        <tr>
          <th colspan="1">落地服务机构名称</th>
          <th colspan="1">办公地址</th>
          <th colspan="1">有效状态</th>
          <th colspan="1">成立时间</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>广东智选保险代理有限公司</td>
          <td>广东省广州市南沙区环市大道中29号2222房</td>
          <td>有效</td>
          <td>2007-07-13</td>
        </tr>
        <tr>
          <td>广东智选保险代理有限公司湖北分公司</td>
          <td>湖北省武汉市汉南区兴城大道 288 号 （33）</td>
          <td>有效</td>
          <td>2023-11-01</td>
        </tr>
      </tbody>
    </table>
    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司发生如下变更，特此公告： </p>
        <p>2025年9月30日，我公司法定代表人由郑叶青变更为罗来文，已完成工商变更并更新营业执照。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2025年9月30日</p>
      </div>
    </div>

    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司发生如下变更，特此公告： </p>
        <p>2025年3月4日，我公司免去牟畅原广东智选保险代理有限公司的副总经理职务，特此公告。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2025年3月4日</p>
      </div>
    </div>

    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司已于2025年2月18日取得《广东金融监管局关于罗来文广东智选保险代理有限公司总经理任职资格的批复》，核准罗来文广东智选保险代理有限公司总经理的任职资格，我司已对罗来文进行任命并完成相关审批/报备。 特此公告。
        </p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2025年2月26日</p>
      </div>
    </div>

    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司已于2024年12月3日取得《金融监管局湖北局关于罗来文任职资格的批复》核准罗来文广东智选保险代理有限公司湖北分公司总经理的任职资格，我司已对罗来文进行任命并完成工商变更、更新营业执照。 特此公告。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2025年1月2日</p>
      </div>
    </div>

    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司发生如下变更，特此公告：</p>
        <p>2024年10月8日，我公司任命牟畅为广东智选保险代理有限公司的副总经理，免去牟畅原广东智选保险代理有限公司的总经理职务。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2024年10月10日</p>
      </div>
    </div>

    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司发生如下变更，特此公告：</p>
        <p>一、2024年8月20日，我公司法定代表人由冯杰变更为郑叶青，已完成工商变更并更新营业执照。</p>
        <p>二、2024年8月20日，湖北分公司负责人由冯杰变更为罗来文，已完成工商变更并更新营业执照。</p>
        <p>三、2024年8月20日，我公司免去冯杰湖北分公司负责人的职务，同时任命罗来文为湖北分公司临时负责人，并已向监管提供相关材料报备。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2024年8月27日</p>
      </div>
    </div>

    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司（广东智选保险代理有限公司北京分公司）经营场所已变更为北京市顺义区京密路后沙峪段3号2幢，并已于2024年4月24日完成工商变更并更新营业执照。 特此公告。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2024年5月10日</p>
      </div>
    </div>

    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司已于2023年6月13日取得《广东银保监局关于牟畅任职资格的批复》核准牟畅广东智选保险代理有限公司总经理的任职资格，我司已对牟畅进行任命并于2023年6月27日完成工商变更并更新营业执照。 特此公告。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2023年7月5日</p>
      </div>
    </div>

    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司已于2023年5月6日取得《广东银保监局关于冯杰任职资格的批复》核准冯杰广东智选保险代理有限公司执行董事的任职资格，我司已对冯杰进行任命并于2023年5月15日完成工商变更并更新营业执照。
          特此公告。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2023年5月20日</p>
      </div>
    </div>
    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>
        <div :class="s.boldText">当前互联网保险产品信息详情：</div>
        <el-table
          :data="transformedList"
          row-key='id'
          border
          :span-method="objectSpanMethod"
        >
          <el-table-column
            prop="parentName"
            label="实际销售名称"
            style="overflow:initial;text-overflow:initial;"
          />
          <el-table-column
            prop="name"
            label="备案产品名称"
            style="overflow:initial;text-overflow:initial;"
          />
          <el-table-column
            prop="code"
            label="备案编号/注册产品号"
            style="overflow:initial;text-overflow:initial;"
          />
          <el-table-column
            prop="code2"
            label="报备文件编号"
            style="overflow:initial;text-overflow:initial;"
          >
            <template slot-scope="{ row }">{{ row.code2 || '无' }}</template>
          </el-table-column>
          <el-table-column
            prop="code3"
            label="条款编码"
            style="overflow:initial;text-overflow:initial;"
          >
            <template slot-scope="{ row }">{{ row.code3 || '无' }}</template>
          </el-table-column>
        </el-table>
        </p>
        <img :src="require('../../images/history_ins_detail.png')" style="object-fit:cover;width:100%;" />
      </div>
      <div :class="s.boxDesc2">
        <p>
        <div :class="s.boldText">投诉渠道：</div>
        </p>
        <p>您在购买产品过程中，如发现本公司有关人员违法、违规行为，或认为自身权益受到侵犯，请保留相关证据并向本公司投诉，投诉电话：4000145002</p>
      </div>
      <div :class="s.boxDesc2">
        <p>
        <div :class="s.boldText">如实告知义务：</div>
        </p>
        <p>在您使用本产品进行算价核保以及支付时，请认真如实填写正确的车辆、险别及关系人等信息，如果您提供了错误的信息导致承保失败或其他问题，本产品不负任何法律责任。</p>
      </div>
      <div :class="s.boxDesc2">
        <p>
        <div :class="s.boldText">信息安全承诺：</div>
        </p>
        <p>我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和管理制度，保护您提供给我们的车辆信息、险别信息以及关系人等相关信息隐私不受到非法的泄露或披露给未获取授权的第三方平台，请您放心。</p>
      </div>
      <div :class="s.boxDesc2">
        中国保险行业信息查询地址：<a href="https://icidp.iachina.cn/?columnid_url=201509301401"
          target="_blank">https://icidp.iachina.cn/?columnid_url=201509301401</a>
      </div>
      <div :class="s.boxDesc2">
        <div :class="s.boldText">合作保险公司信息如下：</div>
        <div v-for="(items, key) in insCompanyInfoMap" :key="key" :class="s.boxDesc2Item">
          <div v-for="item in items" :key="item.label">
            {{ item.label }}：
            <a v-if="isLink(item.value)" :href="item.value" target="_blank">{{ item.value }}</a>
            <template v-else>{{ item.value }}</template>
          </div>
        </div>
      </div>
    </div>
    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司已于2023年1月6日取得中国银行保险监督管理委员会广东监管局换发的保险中介许可证，机构编码为202787000000800。</p>
        <p>业务范围及经营区域：在全国区域内（港、澳、台除外）代理销售保险产品；代理收取保险费；代理相关保险业务的损失查勘和理赔；保险监督管理机构批准的其他业务。</p>
        <p>其他变更手续正在办理中。</p>
        <p>特此公告。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2023年1月6日</p>
      </div>
    </div>
    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司发生如下变更，特此公告：</p>
        <p>一、2022年11月15日，公司名称变更，公司名称变更为广东智选保险代理有限公司。公司住址变更为广州市南沙区环市大道中29号2222房。</p>
        <p>二、2022年10月12日，发生公司章程变更。主要变更内容为：公司名称修改为广东智选保险代理有限公司；公司住址修改为广州市南沙区环市大道中29号2222房。</p>
      </div>
      <div :class="s.boxSign">
        <p>广东智选保险代理有限公司</p>
        <p>2022年11月17日</p>
      </div>
    </div>
    <div :class="s.box">
      <h3 :class="s.boxTitle3">公告</h3>
      <div :class="s.boxDesc1">
        <p>我公司发生如下章程变更，特此公告：</p>
        <p>一、2020年10月12日，变更章程第一条，公司名称修改为青岛妙保保险代理有限公司。</p>
        <p>二、2021年03月09日，变更章程第二条，公司住址修改为山东省青岛市市南区福州南路8号中天恒大厦406室。</p>
        <p>三、2022年06月22日，变更章程第二条，公司住址修改为山东省青岛市市南区南京路66号中天恒商务大厦80A；变更章程第五条，公司股东变更为上海妙保保险经纪股份有限公司。</p>
        <p>四、2022年08月01日，变更章程第五条，公司股东变更为广州雪涛企业管理有限公司，91440115MABPJG4F53，出资金额5000万，出资方式货币，出资比例100%。</p>
      </div>
      <div :class="s.boxSign">
        <p>青岛妙保保险代理有限公司</p>
        <p>2022年11月07日</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentPublicInfo',
  data() {
    return {
      list: [
        {
          title: '中华驾乘无忧升级版（小鹏X9互联网专属）',
          children: [
            { name: '中华联合财产保险股份有限公司机动车驾乘人员意外伤害保险A款（互联网专属）', code: 'C00001232312022071033441' },
            { name: '中华联合财产保险股份有限公司附加法定节假日意外伤害保险（互联网专属）', code: 'C00001232322022071135151' },
            { name: '中华联合财产保险股份有限公司附加救护车费用保险（互联网专属）', code: 'C00001231922022071135031' },
            { name: '中华联合财产保险股份有限公司附加出行行李和随身物品损失保险', code: 'C00001232122023032246733' }
          ]
        },
        {
          title: '中华驾乘无忧升级版（小鹏互联网专属）',
          children: [
            { name: '中华联合财产保险股份有限公司机动车驾乘人员意外伤害保险A款（互联网专属）', code: 'C00001232312022071033441' }
          ]
        },
        {
          title: '众安驾乘保',
          children: [
            { name: '众安在线财产保险股份有限公司交通出行人身意外伤害保险条款（互联网）', code: 'C00017932312021120818513' },
            { name: '众安在线财产保险股份有限公司附加意外伤害医疗费用保险（互联网2021 版）', code: 'C00017932522021112402513' },
            { name: '众安在线财产保险股份有限公司附加节假日意外伤害保险（互联网）', code: 'C00017932322021120919403' },
            { name: '众安在线财产保险股份有限公司附加意外伤害救护车费用保险（互联网）', code: 'C00017932522021112201573' },
          ]
        },
        {
          title: '驾乘保升级版',
          children: [
            {
              name: '众安在线财产保险股份有限公司驾乘人员意外伤害保险条款（互联网）',
              code: 'C00017932312021120203903',
              code2: '(众安在线)(备-普通意外保险)【2021】(主)142号'
            },
            {
              name: '众安在线财产保险股份有限公司驾乘人员意外伤害医疗保险条款（互联网2023版A款）',
              code: 'C00017932512023053103813',
              code2: '(众安在线)(备-医疗保险)【2024】(主)089号'
            },
            {
              name: '众安在线财产保险股份有限公司附加节假日意外伤害保险条款',
              code: 'C00017932322021120919403',
              code2: '(众安在线)(备-普通意外保险)【2021】(附)212号'
            },
            {
              name: '众安在线财产保险股份有限公司附加意外伤害住院津贴保险条款（互联网）',
              code: 'C00017932522021120404633',
              code2: '(众安在线)(备-医疗保险)【2021】(附)228号'
            },
            {
              name: '众安在线财产保险股份有限公司营运交通工具乘客意外伤害保险条款（互联网2023版A款）',
              code: 'C00017932312023022834903',
              code2: '(众安在线)(备-普通意外保险)【2024】(主)044号'
            },
            {
              name: '众安在线财产保险股份有限公司附加个人随车物品损失保险条款（互联网版）',
              code: 'C00017932122025071800193'
            }
          ]
        },
        {
          title: '中国太平洋财产保险股份有限公司小鹏汽车驾意险-企业车（互联网）',
          children: [
            {
              name: '中国太平洋财产保险股份有限公司驾乘人员人身意外伤害保险（互联网）',
              code: 'C00001432312022101903341,(太保财险)(备-普通意外保险)【2023】(主) 009号',
              code2: '太保产〔2022〕867号',
              code3: 'C00001432312022101903341'
            },
            {
              name: '中国太平洋财产保险股份有限公司附加团体意外伤害医疗保险（互联网）',
              code: 'C00001432522021122028753,(太保财险)(备-医疗保险)【2021】(附) 282号',
              code2: '太保产〔2021〕1311号',
              code3: 'C00001432522021122028753'
            },
            {
              name: '中国太平洋财产保险股份有限公司附加团体意外伤害住院津贴保险（互联网）',
              code: 'C00001432522021122028633,(太保财险)(备-医疗保险)【2021】(附) 296号',
              code2: '太保产〔2021〕1311号',
              code3: 'C00001432522021122028633'
            },
            {
              name: '中国太平洋财产保险股份有限公司附加团体意外伤害救护车费用保险',
              code: 'C00001431922022042140831,(太保财险)(备-其他)【2023】(附) 072号',
              code2: '太保产【2022】282号',
              code3: 'C00001431922022042140831'
            },
            {
              name: '附加随车行李物品损失保险',
              code: 'H00001432122017052422081,（太保财险）（备-家财）[2014]（附）2号',
              code3: 'H00001432122017052422081'
            },
            {
              name: '中国太平洋财产保险股份有限公司附加家庭家居保障保险（2022版B款）',
              code: 'C00001432122023070602541',
              code2: '太保产〔2023〕379号',
              code3: 'C00001432122023070602541'
            },
            {
              name: '附加公共场所个人责任保险',
              code: 'H00001430922017052422811,（太保财险）（备-责任）[2014]（附）20号',
              code3: 'H00001430922017052422811'
            },
          ]
        },
        {
          title: '中国太平洋财产保险股份有限公司小鹏汽车驾意险-家用车（互联网）',
          children: [
            {
              name: '中国太平洋财产保险股份有限公司驾乘人员人身意外伤害保险（互联网）',
              code: 'C00001432312022101903341,(太保财险)(备-普通意外保险)【2023】(主) 009号',
              code2: '太保产〔2022〕867号',
              code3: 'C00001432312022101903341'
            },
            {
              name: '中国太平洋财产保险股份有限公司附加团体意外伤害医疗保险（互联网）',
              code: 'C00001432522021122028753,(太保财险)(备-医疗保险)【2021】(附) 282号',
              code2: '太保产〔2021〕1311号',
              code3: 'C00001432522021122028753'
            },
            {
              name: '中国太平洋财产保险股份有限公司附加团体意外伤害住院津贴保险（互联网）',
              code: 'C00001432522021122028633,(太保财险)(备-医疗保险)【2021】(附) 296号',
              code2: '太保产〔2021〕1311号',
              code3: 'C00001432522021122028633'
            },
            {
              name: '附加随车行李物品损失保险',
              code: 'H00001432122017052422081,（太保财险）（备-家财）[2014]（附）2号',
              code3: 'H00001432122017052422081'
            },
          ]
        },
        {
          title: '小鹏驾意险 （豪华版）',
          children: [
            {
              name: '阳光财产保险股份有限公司驾乘人员团体意外伤害保险（2022版）（互联网专属）',
              code: 'C00009332312022050788073,(阳光财险)(备-普通意外保险)【2023】(主) 033号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司团体意外伤害保险附加住院津贴保险（互联网专属）',
              code: 'C00009332522022120672121,(阳光财险)(备-医疗保险)【2023】(附) 1162号',
              code2: '阳光产险[2022]583号'
            },
            {
              name: '阳光财产保险股份有限公司附加驾乘人员团体意外伤害医疗保险（2024版）（互联网专属）',
              code: 'C00009332522024061801633',
              code2: '阳光产险〔2024〕403号'
            },
            {
              name: '阳光财产保险股份有限公司家庭财产综合保险A款（2022版）',
              code: 'C00009332112022050779881',
              code2: '阳光产险[2022]216号'
            },
            {
              name: '阳光财产保险股份有限公司附加救护车费用保险A款（互联网专属）',
              code: 'C00009331922022050788173,(阳光财险)(备-其他)【2022】(附) 064号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司假日团体意外伤害保险2022版（互联网专属）',
              code: 'C00009332312022050788063,(阳光财险)(备-普通意外保险)【2023】(主) 038号',
              code2: '阳光产险[2022]215号'
            }
          ]
        },
        {
          title: '小鹏驾意险 （基础版）',
          children: [
          {
              name: '阳光财产保险股份有限公司驾乘人员团体意外伤害保险（2022版）（互联网专属）',
              code: 'C00009332312022050788073,(阳光财险)(备-普通意外保险)【2023】(主) 033号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司团体意外伤害保险附加住院津贴保险（互联网专属）',
              code: 'C00009332522022120672121,(阳光财险)(备-医疗保险)【2023】(附) 1162号',
              code2: '阳光产险[2022]583号'
            },
            {
              name: '阳光财产保险股份有限公司附加驾乘人员团体意外伤害医疗保险（2024版）（互联网专属）',
              code: 'C00009332522024061801633',
              code2: '阳光产险〔2024〕403号'
            },
            {
              name: '阳光财产保险股份有限公司家庭财产综合保险A款（2022版）',
              code: 'C00009332112022050779881',
              code2: '阳光产险[2022]216号'
            },
            {
              name: '阳光财产保险股份有限公司附加救护车费用保险A款（互联网专属）',
              code: 'C00009331922022050788173,(阳光财险)(备-其他)【2022】(附) 064号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司假日团体意外伤害保险2022版（互联网专属）',
              code: 'C00009332312022050788063,(阳光财险)(备-普通意外保险)【2023】(主) 038号',
              code2: '阳光产险[2022]215号'
            }
          ]
        },
        {
          title: '小鹏驾意险 （升级版）',
          children: [
          {
              name: '阳光财产保险股份有限公司驾乘人员团体意外伤害保险（2022版）（互联网专属）',
              code: 'C00009332312022050788073,(阳光财险)(备-普通意外保险)【2023】(主) 033号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司团体意外伤害保险附加住院津贴保险（互联网专属）',
              code: 'C00009332522022120672121,(阳光财险)(备-医疗保险)【2023】(附) 1162号',
              code2: '阳光产险[2022]583号'
            },
            {
              name: '阳光财产保险股份有限公司附加驾乘人员团体意外伤害医疗保险（2024版）（互联网专属）',
              code: 'C00009332522024061801633',
              code2: '阳光产险〔2024〕403号'
            },
            {
              name: '阳光财产保险股份有限公司家庭财产综合保险A款（2022版）',
              code: 'C00009332112022050779881',
              code2: '阳光产险[2022]216号'
            },
            {
              name: '阳光财产保险股份有限公司附加救护车费用保险A款（互联网专属）',
              code: 'C00009331922022050788173,(阳光财险)(备-其他)【2022】(附) 064号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司假日团体意外伤害保险2022版（互联网专属）',
              code: 'C00009332312022050788063,(阳光财险)(备-普通意外保险)【2023】(主) 038号',
              code2: '阳光产险[2022]215号'
            }
          ]
        },
        {
          title: '小鹏驾意险 （至尊版）',
          children: [
          {
              name: '阳光财产保险股份有限公司驾乘人员团体意外伤害保险（2022版）（互联网专属）',
              code: 'C00009332312022050788073,(阳光财险)(备-普通意外保险)【2023】(主) 033号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司团体意外伤害保险附加住院津贴保险（互联网专属）',
              code: 'C00009332522022120672121,(阳光财险)(备-医疗保险)【2023】(附) 1162号',
              code2: '阳光产险[2022]583号'
            },
            {
              name: '阳光财产保险股份有限公司附加驾乘人员团体意外伤害医疗保险（2024版）（互联网专属）',
              code: 'C00009332522024061801633',
              code2: '阳光产险〔2024〕403号'
            },
            {
              name: '阳光财产保险股份有限公司家庭财产综合保险A款（2022版）',
              code: 'C00009332112022050779881',
              code2: '阳光产险[2022]216号'
            },
            {
              name: '阳光财产保险股份有限公司附加救护车费用保险A款（互联网专属）',
              code: 'C00009331922022050788173,(阳光财险)(备-其他)【2022】(附) 064号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司假日团体意外伤害保险2022版（互联网专属）',
              code: 'C00009332312022050788063,(阳光财险)(备-普通意外保险)【2023】(主) 038号',
              code2: '阳光产险[2022]215号'
            }
          ]
        },
        {
          title: '小鹏驾意险 （尊享版）',
          children: [
          {
              name: '阳光财产保险股份有限公司驾乘人员团体意外伤害保险（2022版）（互联网专属）',
              code: 'C00009332312022050788073,(阳光财险)(备-普通意外保险)【2023】(主) 033号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司团体意外伤害保险附加住院津贴保险（互联网专属）',
              code: 'C00009332522022120672121,(阳光财险)(备-医疗保险)【2023】(附) 1162号',
              code2: '阳光产险[2022]583号'
            },
            {
              name: '阳光财产保险股份有限公司附加驾乘人员团体意外伤害医疗保险（2024版）（互联网专属）',
              code: 'C00009332522024061801633',
              code2: '阳光产险〔2024〕403号'
            },
            {
              name: '阳光财产保险股份有限公司家庭财产综合保险A款（2022版）',
              code: 'C00009332112022050779881',
              code2: '阳光产险[2022]216号'
            },
            {
              name: '阳光财产保险股份有限公司附加救护车费用保险A款（互联网专属）',
              code: 'C00009331922022050788173,(阳光财险)(备-其他)【2022】(附) 064号',
              code2: '阳光产险[2022]215号'
            },
            {
              name: '阳光财产保险股份有限公司假日团体意外伤害保险2022版（互联网专属）',
              code: 'C00009332312022050788063,(阳光财险)(备-普通意外保险)【2023】(主) 038号',
              code2: '阳光产险[2022]215号'
            }
          ]
        },
        {
          title: '平安产险交通出行意外伤害保险（互联网版）',
          children: [
            {
              name: '平安产险交通出行意外伤害保险（互联网版）',
              code: 'C00001732312022080414693',
              code2: '(平安财险)(备-普通意外保险)【2022】(主) 134号'
            },
          ]
        },
        {
          title: '平安产险附加救护车费用补偿保险',
          children: [
            {
              name: '平安产险附加救护车费用补偿保险',
              code: 'C00001732522023091851931',
              code2: '(平安财险)(备-医疗保险)【2023】(附) 118号'
            },
          ]
        },
        {
          title: '平安产险法律费用补偿保险',
          children: [
            {
              name: '平安产险法律费用补偿保险',
              code: 'C00001731912022061332303',
              code2: '(平安财险)(备-其他)【2022】(主) 045号'
            },
          ]
        },
        {
          title: '平安家庭财产保险',
          children: [
            {
              name: '平安家庭财产保险',
              code: 'C00001732112019121811592',
              code2: '(平安财险)(备-普通家财险)【2020】(主) 052号'
            },
          ]
        },
        {
          title: '平安个人随车物品损失保险',
          children: [
            {
              name: '平安个人随车物品损失保险',
              code: 'H00001732112017050450351',
              code2: '平安财险（备-家财）[2014]主20号'
            },
          ]
        },
        {
          title: '机动车交强险',
          children: [
            {
              name: '机动车交通事故责任强制保险',
              code2: '平保产发〔2020〕1271号'
            },
          ]
        },
        {
          title: '新能源汽车商业保险',
          children: [
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车损失保险（NEV21111101）',
              code: '(平安财险)(备-机动车辆保险)【2024】(主) 221号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111101'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车第三者责任保险（NEV21111102）',
              code: '(平安财险)(备-机动车辆保险)【2024】(主) 217号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111102'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车车上人员责任保险（NEV21111103）',
              code: '(平安财险)(备-机动车辆保险)【2024】(主) 215号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111103'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加外部电网故障损失险（NEV21111201）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 173号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111201'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加自用充电桩损失保险（NEV21111202）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 209号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111202'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加自用充电桩责任保险（NEV21111203）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 206号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111203'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加绝对免赔率特约条款（NEV21111204）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 188号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111204'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车轮单独损失险（NEV21111205）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 172号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111205'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加新增加设备损失险（NEV21111206）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 196号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111206'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车身划痕损失险（NEV21111207）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 214号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111207'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加修理期间费用补偿险（NEV21111208）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 174号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111208'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车上货物责任险（NEV21111209）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 187号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111209'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加精神损害抚慰金责任险（NEV21111210）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 183号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111210'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加法定节假日限额翻倍险（NEV21111211）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 184号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111211'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加医保外医疗费用责任险（NEV21111212）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 199号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111212'
            },
            {
              name: '中国平安财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加新能源汽车增值服务特约条款（NEV21111213）',
              code: '(平安财险)(备-机动车辆保险)【2024】(附) 213号',
              code2: '平保产发〔2024〕793号',
              code3: 'NEV21111213'
            }
          ]
        },
        {
          title: '平安行鹏友安心自驾险（互联网版）',
          children: [
            {
              name: '平安产险旅行意外伤害保险（互联网版）（2025版）',
              code: 'C00001732312025112831423'
            },
            {
              name: '平安产险附加旅行期间医疗费用补偿保险（互联网版）',
              code: 'C00001732522022011201311',
              code2: '(平安财险)(备-医疗保险)【2022】(附) 039号'
            },
            {
              name: '平安产险附加旅行住院津贴保险（互联网版）',
              code: 'C00001732522022011201301',
              code2: '(平安财险)(备-医疗保险)【2022】(附) 041号'
            },
            {
              name: '平安产险附加自驾游意外伤害保险（互联网版）',
              code: 'C00001732322021120306483',
              code2: '(平安财险)(备-普通意外保险)【2022】(附) 012号'
            },
            {
              name: '平安产险附加节假日约定保额给付保险（互联网版）',
              code: 'C00001732322022020805441',
              code2: '(平安财险)(备-普通意外保险)【2022】(附) 022号'
            },
            {
              name: '平安产险附加旅行急性病身故或全残保险（互联网版）',
              code: 'C00001731922022011979393',
              code2: '(平安财险)(备-其他)【2022】(附) 024号'
            },
            {
              name: '平安个人出行不便损失补偿保险',
              code: 'C00001731912019061412902',
              code2: '(平安财险)(备-其他)【2020】(主) 039号'
            },
            {
              name: '平安产险附加高风险运动意外伤害保险（互联网版）（2025版）',
              code: 'C00001732322025062425843',
              code2: '(平安财险)(备-普通意外保险)【2025】(附) 199号'
            },
            {
              name: '平安产险附加高原反应意外伤害保险（互联网版）',
              code: 'C00001732322021121316013',
              code2: '(平安财险)(备-普通意外保险)【2022】(附) 005号'
            },
            {
              name: '平安产险急性肠胃炎健康保险（互联网版）',
              code: 'C00001732512021122438083',
              code2: '(平安财险)(备-医疗保险)【2022】(主) 003号'
            }
          ]
        },
        {
          title: '中国人寿财险新能源车险',
          children: [
            {
              name: '新能源汽车驾乘人员意外伤害保险示范条款（试行）驾乘人员意外伤害保险(NEV21112101)',
              code: '(国寿财险)(备-机动车辆保险)[2024](主)042号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车驾乘人员意外伤害保险示范条款（试行）附加医保外医疗费用补偿险(NEV21112202)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)310号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车驾乘人员意外伤害保险示范条款（试行）附加住院津贴保险(NEV21112201)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)316号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）新能源汽车车上人员责任保险(NEV21111103)',
              code: '(国寿财险)(备-机动车辆保险)[2024](主)045号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）新能源汽车第三者责任保险(NEV21111102)',
              code: '(国寿财险)(备-机动车辆保险)[2024](主)034号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）新能源汽车损失保险(NEV21111101)',
              code: '(国寿财险)(备-机动车辆保险)[2024](主)031号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加新能源汽车增值服务特约条款(NEV21111213)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)313号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加医保外医疗费用责任险(NEV21111212)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)298号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加法定节假日限额翻倍险(NEV21111211)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)299号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加精神损害抚慰金责任险(NEV21111210)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)323号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加车上货物责任险(NEV21111209)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)297号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加修理期间费用补偿险(NEV21111208)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)288号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加车身划痕损失险(NEV21111207)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)308号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加新增加设备损失险(NEV21111206)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)317号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加车轮单独损失险(NEV21111205)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)321号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加绝对免赔率特约条款(NEV21111204)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)296号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加自用充电桩责任保险(NEV21111203)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)315号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加自用充电桩损失保险(NEV21111202)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)304号',
              code2: '国寿财险发〔2024〕1248号'
            },
            {
              name: '新能源汽车商业保险示范条款（试行）附加外部电网故障损失险(NEV21111201)',
              code: '(国寿财险)(备-机动车辆保险)[2024](附)327号',
              code2: '国寿财险发〔2024〕1248号'
            }
          ]
        },
        {
          title: '中国人寿财险交强险',
          children: [
            {
              name: '机动车交通事故责任强制保险条款',
              code: '银保监复〔2020〕666号',
              code2: '国寿财险发〔2020〕998号'
            }
          ]
        },
        {
          title: '小鹏驾乘无忧（个人5座互联网专属）基础版、升级版、标准版',
          children: [
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）条款',
              code: 'C00010832312022033026591,(国寿财险)(备-普通意外保险)[2022](主)055号',
              code2: '国寿财险发〔2022〕308号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加意外伤害事故节假日限额翻倍保险条款',
              code: 'C00010832322022052610403,(国寿财险)(备-普通意外保险)[2022](附)059号',
              code2: '国寿财险发〔2022〕677号'
            },
            {
              name: '意外伤害保险（互联网专属）附加超龄人员保险条款',
              code: 'C00010831922022042970901,(国寿财险)(备-其他)[2023](附)402号',
              code2: '国寿财险发〔2022〕539号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加随车行李物品保险条款',
              code: 'C00010832322022042161773,(国寿财险)(备-普通意外保险)[2022](附)595号',
              code2: '国寿财险发〔2022〕416号'
            },
            {
              name: '个人出行不便损失补偿保险条款',
              code: 'C00010832112023040360473,(国寿财险)(备-普通家财险)[2023](主)109号',
              code2: '国寿财险发〔2023〕250号'
            },
            {
              name: '玻璃贴膜保险条款',
              code: 'C00010832112023072401671,(国寿财险)(备-普通家财险)[2023](主)132号',
              code2: '国寿财险发〔2023〕591号'
            },
            {
              name: '家庭财产保险条款',
              code: 'C00010832112022042974541,(国寿财险)(备-普通家财险)[2022](主)020号',
              code2: '国寿财险发〔2022〕557号'
            },
            {
              name: '家庭财产保险附加第三者责任保险条款',
              code: 'C00010832122022042869001,(国寿财险)(备-普通家财险)[2023](附)050号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加管道破裂及水渍保险条款',
              code: 'C00010832122022042972881,(国寿财险)(备-普通家财险)[2023](附)085号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加盗窃、抢劫保险条款',
              code: 'C00010832122022042869081,(国寿财险)(备-普通家财险)[2022](附)965号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加个人银行账户资金安全保险条款',
              code: 'C00010832122022042972841,(国寿财险)(备-普通家财险)[2023](附)246号',
              code2: '国寿财险发〔2022〕522号'
            }
          ]
        },
        {
          title: '小鹏驾乘无忧（个人5座互联网专属）豪华版、尊享版、至尊版',
          children: [
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）条款',
              code: 'C00010832312022033026591,(国寿财险)(备-普通意外保险)[2022](主)055号',
              code2: '国寿财险发〔2022〕308号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加意外伤害事故节假日限额翻倍保险条款',
              code: 'C00010832322022052610403,(国寿财险)(备-普通意外保险)[2022](附)059号',
              code2: '国寿财险发〔2022〕677号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加救护车费用保险条款',
              code: 'C00010832322022042867291，(国寿财险)(备-普通意外保险)[2022](附)408号',
              code2: '国寿财险发〔2022〕538号'
            },
            {
              name: '意外伤害保险（互联网专属）附加超龄人员保险条款',
              code: 'C00010831922022042970901,(国寿财险)(备-其他)[2023](附)402号',
              code2: '国寿财险发〔2022〕539号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加随车行李物品保险条款',
              code: 'C00010832322022042161773,(国寿财险)(备-普通意外保险)[2022](附)595号',
              code2: '国寿财险发〔2022〕416号'
            },
            {
              name: '个人出行不便损失补偿保险条款',
              code: 'C00010832112023040360473,(国寿财险)(备-普通家财险)[2023](主)109号',
              code2: '国寿财险发〔2023〕250号'
            },
            {
              name: '玻璃贴膜保险条款',
              code: 'C00010832112023072401671,(国寿财险)(备-普通家财险)[2023](主)132号',
              code2: '国寿财险发〔2023〕591号'
            },
            {
              name: '家庭财产保险条款',
              code: 'C00010832112022042974541,(国寿财险)(备-普通家财险)[2022](主)020号',
              code2: '国寿财险发〔2022〕557号'
            },
            {
              name: '家庭财产保险附加第三者责任保险条款',
              code: 'C00010832122022042869001,(国寿财险)(备-普通家财险)[2023](附)050号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加管道破裂及水渍保险条款',
              code: 'C00010832122022042972881,(国寿财险)(备-普通家财险)[2023](附)085号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加盗窃、抢劫保险条款',
              code: 'C00010832122022042869081,(国寿财险)(备-普通家财险)[2022](附)965号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加个人银行账户资金安全保险条款',
              code: 'C00010832122022042972841,(国寿财险)(备-普通家财险)[2023](附)246号',
              code2: '国寿财险发〔2022〕522号'
            }
          ]
        },
        {
          title: '小鹏驾乘无忧（个人7座互联网专属）基础版',
          children: [
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）条款',
              code: 'C00010832312022033026591,(国寿财险)(备-普通意外保险)[2022](主)055号',
              code2: '国寿财险发〔2022〕308号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加意外伤害事故节假日限额翻倍保险条款',
              code: 'C00010832322022052610403,(国寿财险)(备-普通意外保险)[2022](附)059号',
              code2: '国寿财险发〔2022〕677号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加救护车费用保险条款',
              code: 'C00010832322022042867291，(国寿财险)(备-普通意外保险)[2022](附)408号',
              code2: '国寿财险发〔2022〕538号'
            },
            {
              name: '意外伤害保险（互联网专属）附加超龄人员保险条款',
              code: 'C00010831922022042970901,(国寿财险)(备-其他)[2023](附)402号',
              code2: '国寿财险发〔2022〕539号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加随车行李物品保险条款',
              code: 'C00010832322022042161773,(国寿财险)(备-普通意外保险)[2022](附)595号',
              code2: '国寿财险发〔2022〕416号'
            },
            {
              name: '个人出行不便损失补偿保险条款',
              code: 'C00010832112023040360473,(国寿财险)(备-普通家财险)[2023](主)109号',
              code2: '国寿财险发〔2023〕250号'
            },
            {
              name: '玻璃贴膜保险条款',
              code: 'C00010832112023072401671,(国寿财险)(备-普通家财险)[2023](主)132号',
              code2: '国寿财险发〔2023〕591号'
            },
            {
              name: '家庭财产保险条款',
              code: 'C00010832112022042974541,(国寿财险)(备-普通家财险)[2022](主)020号',
              code2: '国寿财险发〔2022〕557号'
            },
            {
              name: '家庭财产保险附加第三者责任保险条款',
              code: 'C00010832122022042869001,(国寿财险)(备-普通家财险)[2023](附)050号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加管道破裂及水渍保险条款',
              code: 'C00010832122022042972881,(国寿财险)(备-普通家财险)[2023](附)085号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加盗窃、抢劫保险条款',
              code: 'C00010832122022042869081,(国寿财险)(备-普通家财险)[2022](附)965号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加个人银行账户资金安全保险条款',
              code: 'C00010832122022042972841,(国寿财险)(备-普通家财险)[2023](附)246号',
              code2: '国寿财险发〔2022〕522号'
            }
          ]
        },
        {
          title: '小鹏驾乘无忧（个人7座互联网专属）升级版、标准版、豪华版、尊享版、至尊版',
          children: [
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）条款',
              code: 'C00010832312022033026591,(国寿财险)(备-普通意外保险)[2022](主)055号',
              code2: '国寿财险发〔2022〕308号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加意外伤害事故节假日限额翻倍保险条款',
              code: 'C00010832322022052610403,(国寿财险)(备-普通意外保险)[2022](附)059号',
              code2: '国寿财险发〔2022〕677号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加救护车费用保险条款',
              code: 'C00010832322022042867291，(国寿财险)(备-普通意外保险)[2022](附)408号',
              code2: '国寿财险发〔2022〕538号'
            },
            {
              name: '意外伤害保险（互联网专属）附加超龄人员保险条款',
              code: 'C00010831922022042970901,(国寿财险)(备-其他)[2023](附)402号',
              code2: '国寿财险发〔2022〕539号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加随车行李物品保险条款',
              code: 'C00010832322022042161773,(国寿财险)(备-普通意外保险)[2022](附)595号',
              code2: '国寿财险发〔2022〕416号'
            },
            {
              name: '个人出行不便损失补偿保险条款',
              code: 'C00010832112023040360473,(国寿财险)(备-普通家财险)[2023](主)109号',
              code2: '国寿财险发〔2023〕250号'
            },
            {
              name: '玻璃贴膜保险条款',
              code: 'C00010832112023072401671,(国寿财险)(备-普通家财险)[2023](主)132号',
              code2: '国寿财险发〔2023〕591号'
            },
            {
              name: '家庭财产保险条款',
              code: 'C00010832112022042974541,(国寿财险)(备-普通家财险)[2022](主)020号',
              code2: '国寿财险发〔2022〕557号'
            },
            {
              name: '家庭财产保险附加第三者责任保险条款',
              code: 'C00010832122022042869001,(国寿财险)(备-普通家财险)[2023](附)050号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加管道破裂及水渍保险条款',
              code: 'C00010832122022042972881,(国寿财险)(备-普通家财险)[2023](附)085号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加盗窃、抢劫保险条款',
              code: 'C00010832122022042869081,(国寿财险)(备-普通家财险)[2022](附)965号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加个人银行账户资金安全保险条款',
              code: 'C00010832122022042972841,(国寿财险)(备-普通家财险)[2023](附)246号',
              code2: '国寿财险发〔2022〕522号'
            },
            {
              name: '家庭财产保险附加家用电器用电安全保险条款',
              code: 'C00010832122022042972871，(国寿财险)(备-普通家财险)[2023](附)248号',
              code2: '国寿财险发〔2022〕522号'
            }
          ]
        },
        {
          title: '小鹏驾乘无忧（企业5座互联网专属）基础版、升级版、标准版',
          children: [
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）条款',
              code: 'C00010832312022033026591,(国寿财险)(备-普通意外保险)[2022](主)055号',
              code2: '国寿财险发〔2022〕308号'
            },
            {
              name: '意外伤害保险（互联网专属）附加超龄人员保险条款',
              code: 'C00010831922022042970901,(国寿财险)(备-其他)[2023](附)402号',
              code2: '国寿财险发〔2022〕539号'
            },
            {
              name: '国内公路运输随车行李物品定额保险条款',
              code: '09IT2017001080066',
              code2: '航运注册产品无报备文件编号'
            }
          ]
        },
        {
          title: '小鹏驾乘无忧（企业5座互联网专属）豪华版、尊享版、至尊版',
          children: [
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）条款',
              code: 'C00010832312022033026591,(国寿财险)(备-普通意外保险)[2022](主)055号',
              code2: '国寿财险发〔2022〕308号'
            },
            {
              name: '意外伤害保险（互联网专属）附加超龄人员保险条款',
              code: 'C00010831922022042970901,(国寿财险)(备-其他)[2023](附)402号',
              code2: '国寿财险发〔2022〕539号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加救护车费用保险条款',
              code: 'C00010832322022042867291，(国寿财险)(备-普通意外保险)[2022](附)408号',
              code2: '国寿财险发〔2022〕538号'
            },
            {
              name: '国内公路运输随车行李物品定额保险条款',
              code: '09IT2017001080066',
              code2: '航运注册产品无报备文件编号'
            }
          ]
        },
        {
          title: '小鹏驾乘无忧（企业7座互联网专属）基础版、升级版、标准版',
          children: [
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）条款',
              code: 'C00010832312022033026591,(国寿财险)(备-普通意外保险)[2022](主)055号',
              code2: '国寿财险发〔2022〕308号'
            },
            {
              name: '意外伤害保险（互联网专属）附加超龄人员保险条款',
              code: 'C00010831922022042970901,(国寿财险)(备-其他)[2023](附)402号',
              code2: '国寿财险发〔2022〕539号'
            },
            {
              name: '国内公路运输随车行李物品定额保险条款',
              code: '09IT2017001080066',
              code2: '航运注册产品无报备文件编号'
            }
          ]
        },
        {
          title: '小鹏驾乘无忧（企业7座互联网专属）豪华版、尊享版、至尊版',
          children: [
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）条款',
              code: 'C00010832312022033026591,(国寿财险)(备-普通意外保险)[2022](主)055号',
              code2: '国寿财险发〔2022〕308号'
            },
            {
              name: '意外伤害保险（互联网专属）附加超龄人员保险条款',
              code: 'C00010831922022042970901,(国寿财险)(备-其他)[2023](附)402号',
              code2: '国寿财险发〔2022〕539号'
            },
            {
              name: '人身意外伤害保险（特定场景B）（互联网专属）附加救护车费用保险条款',
              code: 'C00010832322022042867291，(国寿财险)(备-普通意外保险)[2022](附)408号',
              code2: '国寿财险发〔2022〕538号'
            },
            {
              name: '国内公路运输随车行李物品定额保险条款',
              code: '09IT2017001080066',
              code2: '航运注册产品无报备文件编号'
            }
          ]
        },
        {
          title: '“如意行”驾乘人员意外伤害保险(自营)',
          children: [
            {
              name: '交通出行人身意外伤害保险A款(互联网专属)条款',
              code: 'C00000232312021122438183',
              code2: '(人保财险)(备-普通意外保险)【2021】(主) 269号'
            },
            {
              name: '附加法定节假日意外伤害双倍给付保险(互联网专属)条款',
              code: 'C00000231922021123170103',
              code2: '(人保财险)(备-其他)【2022】(附) 196号'
            },
            {
              name: '附加意外伤害医疗保险B款(互联网专属)条款',
              code: 'C00000232522021122838463',
              code2: '(人保财险)(备-医疗保险)【2021】(附) 853号'
            },
            {
              name: '附加意外伤害住院津贴保险C款(互联网专属)条款',
              code: 'C00000232522021122434823',
              code2: '(人保财险)(备-医疗保险)【2021】(附) 844号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网5座）基础版A',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网5座）标准版B',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网5座）旗舰版C',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网5座）尊享版D',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网5座）豪华版E',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网7座）基础版A',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网7座）标准版B',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网7座）旗舰版C',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网7座）尊享版D',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '小鹏车商专属方案（互联网7座）豪华版E',
          children: [
            {
              name: '申能财产保险股份有限公司司乘人员意外伤害保险（互联网）条款',
              code: 'C00026232312025022808963',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害医疗保险（互联网）条款',
              code: 'C00026232522025022810903',
              code2: '申保[2025]74号'
            },
            {
              name: '申能财产保险股份有限公司附加交通意外伤害住院医疗津贴保险（互联网）条款',
              code: 'C00026232522025022809163',
              code2: '申保[2025]74号'
            }
          ]
        },
        {
          title: '鹏行无忧意外险',
          children: [
            {
              name: '中国大地财产保险股份有限公司驾乘交通工具团体意外伤害保险（2024款）条款(CF1102989)',
              code: 'C00001032312024032958731',
              code2: '大地财保发〔2024〕269号'
            },
            {
              name: '中国大地财产保险股份有限公司附加团体通用意外医疗保险（A款）条款(CF2101270)',
              code: 'C00001032522022111739701',
              code2: '大地财保发[2022]765号'
            },
            {
              name: '中国大地财产保险股份有限公司附加团体意外面部整容医疗保险条款(CF2100270)',
              code: 'C00001032522022053110831',
              code2: '大地财保发[2022]351号'
            },
            {
              name: '中国大地财产保险股份有限公司附加团体法定节假日意外伤害保额调整保险（2025版）条款(CF2101108)',
              code: 'C00001032322025041016953',
              code2: '大地财保发〔2025〕227号'
            }
          ]
        },
        {
          title: '新能源车险',
          children: [
            {
              name: '中国大地财产保险股份有限公司新能源汽车驾乘人员意外伤害保险示范条款（试行）附加医保外医疗费用补偿险（NEV21112202）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 192号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车驾乘人员意外伤害保险示范条款（试行）附加住院津贴保险（NEV21112201）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 190号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车驾乘人员意外伤害保险示范条款（试行）驾乘人员意外伤害保险（NEV21112101）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(主) 080号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车轮单独损失险（NEV21111205）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 198号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车上货物责任险（NEV21111209）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 200号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加车身划痕损失险（NEV21111207）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 196号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加法定节假日限额翻倍险（NEV21111211）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 202号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加精神损害抚慰金责任险（NEV21111210）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 188号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加绝对免赔率特约条款（NEV21111204）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 199号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加外部电网故障损失险（NEV21111201）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 191号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加新能源汽车增值服务特约条款（NEV21111213）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 195号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加新增加设备损失险（NEV21111206）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 201号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加修理期间费用补偿险（NEV21111208）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 197号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加医保外医疗费用责任险（NEV21111212）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 193号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加自用充电桩损失保险（NEV21111202）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 194号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）附加自用充电桩责任保险（NEV21111203）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(附) 189号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车车上人员责任保险（NEV21111103）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(主) 079号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车第三者责任保险（NEV21111102）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(主) 081号',
              code2: '大地财保发〔2021〕919号'
            },
            {
              name: '中国大地财产保险股份有限公司新能源汽车商业保险示范条款（试行）新能源汽车损失保险（NEV21111101）',
              code: '(中国大地保险)(备-机动车辆保险)【2021】(主) 082号',
              code2: '大地财保发〔2021〕919号'
            }
          ]
        },
        {
          title: '汽车险',
          children: [
            {
              name: '机动车交通事故责任强制保险条款',
              code: '银保监复【2020】611号',
              code2: '大地财保发〔2020〕514号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）机动车损失保险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(主) 122号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）机动车第三者责任保险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(主) 119号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）机动车车上人员责任保险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(主) 126号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加绝对免赔率特约条款',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 369号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加车轮单独损失险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 366号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加新增加设备损失险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 353号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加车身划痕损失险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 357号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加修理期间费用补偿险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 352号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加发动机进水损坏除外特约条款',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 373号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加车上货物责任险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 351号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加精神损害抚慰金责任险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 355号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加法定节假日限额翻倍险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 372号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加医保外医疗费用责任险',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 371号',
              code2: '大地财保发〔2020)520号'
            },
            {
              name: '中国大地财产保险股份有限公司机动车单程提车保险示范条款（2020版）附加机动车增值服务特约条款',
              code: '(中国大地保险)(备-机动车辆保险)【2020】(附) 350号',
              code2: '大地财保发〔2020)520号'
            }
          ]
        },
        {
          title: '畅行无忧',
          children: [
            {
              name: '太平财产保险有限公司交通出行意外伤害保险（互联网专属）',
              code: 'C00002632312023090846101,(太平财险)(备-普通意外保险)【2023】(主)090号',
              code2: '太平财〔2023〕392号'
            },
            {
              name: '太平财产保险有限公司附加意外伤害医疗保险（互联网专属2022版）',
              code: 'C00002632522022053009601,(太平财险)(备-医疗保险)【2022】(附)072号',
              code2: '太平财〔2022〕254号'
            },
            {
              name: '太平财产保险有限公司附加意外伤害住院津贴保险（互联网专属）',
              code: 'C00002632522021122833693,(太平财险)(备-医疗保险)【2022】(附)006号',
              code2: '太平财〔2021〕632号'
            },
            {
              name: '太平财产保险有限公司附加意外伤害救护车费用保险（互联网专属）',
              code: 'C00002631922022071132863,(太平财险)(备-其他)【2022】(附) 245号',
              code2: '太平财〔2022〕342号'
            },
            {
              name: '太平财产保险有限公司公共交通工具乘客意外伤害保险（互联网专属2022版）',
              code: 'C00002632312022053009541,(太平财险)(备-普通意外保险)【2022】(主) 046号',
              code2: '太平财〔2022〕254号'
            },
            {
              name: '太平财产保险有限公司附加个人行李损失保险（2021版）',
              code: 'C00002632122021032631072,(太平财险)(备-普通家财险)【2021】(附) 035号',
              code2: '太平财〔2021〕154号'
            }
          ]
        }
      ],
      insCompanyInfoMap: {
        picc: [
          { label: '机构名称', value: '中国人民财产保险股份有限公司' },
          { label: '官方网址', value: 'https://property.picc.com/' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'https://property.picc.com/gkxx/jbxx/gsgk/gfzjg/' },
          { label: '客服电话', value: '95518' },
          { label: '合作时间', value: '2025.6.30-2028.6.30' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'https://e.picc.com/servicecenter/#/policy/policyInquiryDownload' }
        ],
        paic: [
          { label: '机构名称', value: '中国平安财产保险股份有限公司' },
          { label: '官方网址', value: 'https://property.pingan.com' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'https://property.pingan.com/gongkaixinxipilu/fenzhijigou_2.shtml' },
          { label: '客服电话', value: '95511' },
          { label: '合作时间', value: '2025.1.1-2028.1.1' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'http://property.pingan.com/kehufuwu/baodanchaxun.shtml' }
        ],
        cpic: [
          { label: '机构名称', value: '中国太平洋财产保险股份有限公司' },
          { label: '官方网址', value: 'www.cpic.com.cn' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'https://www.cpic.com.cn/xccbx/gygs/fzjg/index.shtml' },
          { label: '客服电话', value: '95500' },
          { label: '合作时间', value: '2025.1.1-2027.1.1' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'https://service.cpic.com.cn/index.html?hit=ShouyeDhDating' }
        ],
        gpic: [
          { label: '机构名称', value: '中国人寿财产保险股份有限公司' },
          { label: '官方网址', value: 'www.chinalife-p.com.cn' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'http://www.chinalife-p.com.cn/#/customerService?component=OrganizationNetwork' },
          { label: '客服电话', value: '95519' },
          { label: '合作时间', value: '2023.3.1-2026.2.28' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'https://www.chinalife-p.com.cn/#/detail?navId=47&id=4930' }
        ],
        cicp: [
          { label: '机构名称', value: '中华联合财产保险股份有限公司' },
          { label: '官方网址', value: 'https://property.cic.cn/' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'https://property.cic.cn/serviceArea/index.jhtml' },
          { label: '客服电话', value: '95585' },
          { label: '合作时间', value: '2023.4.24-2026.4.23' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'http://query.cic.cn/policys/pages' }
        ],
        ccic: [
          { label: '机构名称', value: '中国大地财产保险股份有限公司' },
          { label: '官方网址', value: 'http://www.ccic-net.com.cn/' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'http://www.ccic-net.com.cn/zjdd/fzjg/' },
          { label: '客服电话', value: '95590' },
          { label: '合作时间', value: '2025.6.1-2028.6.1' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'https://www.95590.cn/ebiz/view/onlineBusinessNew/onlineEPolicyDownload.jsp' }
        ],
        ssic: [
          { label: '机构名称', value: '阳光财产保险股份有限公司' },
          { label: '官方网址', value: 'https://www.4000-000-000.com' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'https://www.4000-000-000.com/#/gridchek' },
          { label: '客服电话', value: '95510' },
          { label: '合作时间', value: '2025.1.1-2028.12.31' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'https://www.4000-000-000.com/#/pltabsheet?menuId=634&type=menu' }
        ],
        snpic: [
          { label: '机构名称', value: '申能财产保险股份有限公司' },
          { label: '官方网址', value: 'https://www.95505.com.cn/' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'https://www.95505.com.cn/institutional_network/819/index.html' },
          { label: '客服电话', value: '95505' },
          { label: '合作时间', value: '2025.5.20-2026.5.19' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'https://www.95505.com.cn/customer_service/electronic_policy_download.html' }
        ],
        zaic: [
          { label: '机构名称', value: '众安在线财产保险股份有限公司' },
          { label: '官网地址', value: 'https://www.zhongan.com/' },
          { label: '公司地址', value: '上海市黄浦区圆明园路169号协进大楼4F-5F' },
          { label: '客服电话', value: '10109955' },
          { label: '合作时间', value: '2025.2.27-2026.2.28' },
          { label: '业务合作范围', value: '互联网业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'https://www.zhongan.com/open/policy/policyVerify.htm' }
        ],
        tpic: [
          { label: '机构名称', value: '太平财产保险有限公司' },
          { label: '官方网址', value: 'https://caixian.cntaiping.com' },
          { label: '省级分支机构和落地服务机构信息（名称、地址、电话等）', value: 'https://caixian.cntaiping.com/info-gsgk' },
          { label: '客服电话', value: '95589' },
          { label: '合作时间', value: '2025年1月1日至2027年12月31日' },
          { label: '业务合作范围', value: '互联网业务、线下业务' },
          { label: '互联网保险产品及保单的查询和验真途径', value: 'https://ectp.tpi.cntaiping.com/TPEBizWeb/pages/B2C/xiamenVehicleQuery/begin.do' }
        ]
      }
    }
  },
  computed: {
    s() {
      return this.$style;
    },
    transformedList() {
      const results = []
      this.list.forEach((parent, parentIndex) => {
        const parentId = parentIndex << 16
        parent.children.forEach((child, childIndex) => {
          results.push(Object.assign({}, child, {
            id: parentId | (childIndex + 1),
            parentId,
            parentName: parent.title
          }))
        })
      })
      return results
    }
  },
  methods: {
    isLink(value) {
      if (!value) {
        return false;
      }
      if (value.startsWith('https://')) {
        return true
      }
      if (value.startsWith('http://')) {
        return true
      }
      return value.startsWith('www.');
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex !== 0) {
        return undefined
      }

      const prevRow = rowIndex > 0 ? this.transformedList[rowIndex - 1] : null
      if (prevRow && prevRow.parentId === row.parentId) {
        return {
          rowspan: 0,
          colspan: 0
        }
      }

      const rows = this.transformedList.filter(item => item.parentId === row.parentId)
      return {
        rowspan: rows.length || 1,
        colspan: 1
      }
    }
  }
};
</script>

<style scoped lang="less" module>
.contentPublicInfo {
  font-size: 15px;
  line-height: 30px;
  text-indent: 2em;
  box-sizing: border-box;

  .textLeft {
    text-align: left;
  }

  .boldText {
    font-weight: bold;
  }

  .infosTable {
    width: 700pt;
    text-align: center;
    border: 0.5pt solid #333;

    tbody tr {
      td {
        font-size: 10pt;
        font-weight: 700;
        border-left: 0.5pt solid #333;
        border-bottom: 0.5pt solid #333;

        &:first-child {
          border-left: none;
        }
      }

      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }

  .orgsTable {
    margin-top: 48pt;
    text-align: center;
    border: 0.5pt solid #333;
    width: 700pt;

    thead tr {
      th {
        font-size: 14pt;
        line-height: 24pt;
        font-weight: 400;
        padding: 0;
        border-left: 0.5pt solid #333;

        &:first-child {
          border-left: none;
        }
      }

      &:first-child {
        background-color: rgb(225, 234, 255);

        th {
          font-size: 16pt;
          line-height: 28pt;
          font-weight: 600;
          border-bottom: 0.5pt solid #333;
        }
      }
    }

    tbody tr {
      td {
        font-size: 11pt;
        line-height: 20pt;
        font-weight: 400;
        padding: 0;
        border-top: 0.5pt solid #333;
        border-left: 0.5pt solid #333;

        &:first-child {
          border-left: none;
        }
      }
    }
  }

  .box {
    border: 1px solid #CCC;
    padding: 20pt;
    margin-top: 24pt;

    .boxTitle3 {
      text-align: center;
    }

    .boxDesc1 {
      font-size: 10pt;
    }

    .boxDesc2 {
      font-size: 10pt;
      margin-top: 12pt;

      .boxDesc2Item {
        margin-top: 0pt;
      }

      .boxDesc2Item + .boxDesc2Item {
        margin-top: 12pt;
      }
    }

    .boxSign {
      font-size: 10pt;
      text-align: right
    }
  }
}
</style>
